import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { EmailVerificationCurrentState } from "./EmailVerificationCurrentState";
import { useEmailValidation } from "./hooks/useEmailValidation";
import { useEmailVerification } from "./hooks/useEmailVerification";
import { useHeightTransition } from "./hooks/useHeightTransition";

export const CheckoutFormEmailVerification = () => {
  const {
    state,
    verifyEmail,
    handleEmailChange,
    startValidation,
    handleValidationSuccess,
    handleValidationError,
    handleOTPSubmit,
    handlePasswordSubmit,
    handleForgotPasswordSubmit,
    handleResendOTP,
    showOTPForm,
    showPasswordForm,
    showClaimForm,
    resetToInitial,
    handleAuthenticationLinkClick,
  } = useEmailVerification();

  useEmailValidation({
    verifyEmail,
    onEmailChange: handleEmailChange,
    onValidationStart: startValidation,
    onValidationSuccess: handleValidationSuccess,
    onValidationError: handleValidationError,
  });

  const { isTransitioning, currentHeight, displayedStep, contentRef } =
    useHeightTransition({ currentStep: state.step });

  return (
    <div
      className={classNames(
        "border-primary shadow-xs rounded-lg border bg-white",
        "relative w-full overflow-hidden",
        "mx-auto",
        "sm:mx-auto md:mx-0",
      )}
    >
      <div
        className="overflow-hidden transition-all duration-300 ease-out"
        style={{
          height: currentHeight ? `${currentHeight}px` : "auto",
        }}
      >
        <div
          ref={contentRef}
          className={classNames("transition-all duration-200 ease-in-out", {
            "-translate-y-2 opacity-0": isTransitioning,
            "translate-y-0 opacity-100": !isTransitioning,
          })}
        >
          <EmailVerificationCurrentState
            displayedStep={displayedStep}
            state={state}
            onAuthenticationLinkClick={handleAuthenticationLinkClick}
            resetToInitial={resetToInitial}
            showPasswordForm={showPasswordForm}
            showClaimForm={showClaimForm}
            handleOTPSubmit={handleOTPSubmit}
            handleResendOTP={handleResendOTP}
            showOTPForm={showOTPForm}
            handlePasswordSubmit={handlePasswordSubmit}
            handleForgotPasswordSubmit={handleForgotPasswordSubmit}
          />
        </div>
      </div>
    </div>
  );
};
